angular.module('app.controllers').controller('InterestsCtrl', function (interestsListFilter, DataTablesFactory, interestsList) {
    const vm = this;

    vm.interests = interestsList.list;
    vm.stats = interestsList.stats;
    vm.filter = interestsListFilter;

    vm.dt = DataTablesFactory.init({
        scope: vm,
        columnDefs: [
            { type: 'symbol', targets: 1 },
            { type: 'value-pln', targets: 5 },
            { type: 'value-pln', targets: 6 },
        ],
    });
});
